var map = {
	"./logo_ammc.png": 233,
	"./logo_cmc.png": 234,
	"./logo_dtn.png": 235,
	"./logo_dwd.png": 236,
	"./logo_ecmwf.png": 237,
	"./logo_mdl.png": 238,
	"./logo_mercator.png": 239,
	"./logo_ncep.png": 240,
	"./logo_svasek.png": 241,
	"./logo_ukmo.png": 242
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 232;


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/logo_.*\.png$
// module id = 232
// module chunks = 0